export enum GaAnalyticsEvents {
  HOME_OPEN_EVENT = "crm_admin_home_open",
  HOME_OPEN_LABEL = "CRM Admin Home Page",
  GUEST_LIST_OPEN_EVENT = "crm_admin_guest_list_open",
  GUEST_LIST_OPEN_LABEL = "CRM Admin Guest List",
  GUEST_PROFILE_DIRECT_OPEN_EVENT = "crm_admin_profile_direct_visit",
  GUEST_PROFILE_DIRECT_OPEN_LABEL = "CRM Admin Profile Direct Open",
  GUEST_PROFILE_TELEGRAM_OPEN_EVENT = "crm_admin_profile_telegram_visit",
  GUEST_PROFILE_TELEGRAM_OPEN_LABEL = "CRM Admin Profile Telegram Open",
  ACCESS_DENIED_EVENT = "crm_admin_access_denied",
  ACCESS_DENIED_LABEL = "CRM Admin Access Denied Page",
}

export enum GaAnalyticsSource {
  UTM_SOURCE = "telegram",
  TELEGRAM_LINK_REFERER = "t.me",
}
